import React from 'react';
import { motion } from 'framer-motion';
import { Container } from '../components/Container';
export function CustomerQuote() {
  return <section className="relative overflow-hidden border-y border-white/5 bg-[#f4ede1] py-12 sm:py-14" data-id="element-589">
      {/* Warm paper grain */}
      <div aria-hidden className="pointer-events-none absolute inset-0 opacity-[0.06] mix-blend-multiply" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='2' /%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' /%3E%3C/svg%3E\")"
    }} data-id="element-590" />
      <div aria-hidden className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_center,transparent_45%,rgba(120,80,40,0.08)_100%)]" data-id="element-591" />

      <Container className="relative" data-id="element-592">
        <div className="mx-auto flex max-w-5xl flex-col items-center gap-6 lg:flex-row lg:items-center lg:gap-10" data-id="element-593">
          {/* Logo */}
          <img src="https://i.imgur.com/yw34kZP.png" alt="Gridiron Insurance Underwriters" className="h-10 w-auto flex-shrink-0 sm:h-12" data-id="element-594" />

          {/* Quote + body */}
          <blockquote className="flex-1 text-center lg:text-left" data-id="element-595">
            <p className="font-serif-display text-2xl leading-[1.2] tracking-tight text-stone-900 sm:text-3xl" data-id="element-596">
              <span className="text-stone-400" data-id="element-597">“</span>
              Pigeon has delivered an{' '}
              <span className="italic text-stone-900 underline decoration-stone-400 decoration-2 underline-offset-4" data-id="element-598">
                immediate impact
              </span>{' '}
              on our operations.<span className="text-stone-400" data-id="element-599">”</span>
            </p>
            <p className="mt-3 text-sm leading-relaxed text-stone-700" data-id="element-600">
              It's streamlined our follow-up process with seamless document
              uploads and an easy-to-use dashboard. From onboarding to
              post-launch, the Pigeon team has been top-notch.
            </p>
          </blockquote>

          {/* Attribution */}
          <figcaption className="flex flex-shrink-0 items-center justify-center gap-3 lg:flex-col lg:items-end lg:text-right" data-id="element-601">
            <img src="https://cdn.magicpatterns.com/uploads/vhrLLnUVGM9Kx8J8VvrnUu/1739845387132.jpg" alt="Jason Green" className="h-11 w-11 rounded-full border border-stone-300 object-cover" data-id="element-602" />
            <div className="text-left lg:text-right" data-id="element-603">
              <div className="text-sm font-semibold text-stone-900" data-id="element-604">
                Jason Green
              </div>
              <div className="text-xs text-stone-600" data-id="element-605">
                COO, Gridiron Insurance
              </div>
            </div>
          </figcaption>
        </div>
      </Container>
    </section>;
}